import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import store from './store/store';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material';
import { theme } from './utils/theme';
import { SnackbarProvider } from './components/snackbar/SnackbarCustom';
import './i18n'
import './index.css'
import './styles/datePicker.css';
// import './styles/custom.css'
import 'ckeditor5/ckeditor5.css';
import 'moment/locale/th';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'aos/dist/aos.css';


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <ThemeProvider theme={theme}>
    <BrowserRouter basename='/'>
      <Provider store={store}>
        <SnackbarProvider>
          <App />
        </SnackbarProvider>
      </Provider>
    </BrowserRouter>
  </ThemeProvider>
);
reportWebVitals();
